module.exports = __webpack_public_path__ + "img/ashwin.2542326a.jpeg";